const PlayButton = () => {
  return(
    <svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="36.5" cy="36.5" r="35.5" stroke="white" strokeWidth="2"/>
      <path d="M47.0444 36.5001L28.7944 48.4416L28.7944 24.5585L47.0444 36.5001Z" fill="white"/>
    </svg>
  );
};

export default PlayButton;